import React from "react";
import "./styles/work.css";

const Works = () => {
  const data = [
    {
      title: "Integrate Real Opinion",
      content:
        " Plug Real Opinion into your app using our lightweight SDK or webview integration",
    },
    {
      title: "Users Engage & Earn",
      content:
        " Users complete targeted, high-quality surveys and earn coins.",
    },
    {
      title: "Users Withdraw Rewards.",
      content:
        "Users redeem their coins within the Real Opinion platform.",
    },
    {
      title: "You Earn Revenue.",
      content:
        "Each user payout triggers revenue for your app — simple, fair, and rewarding.",
    },
  ];
  return (
    <section className="work-section">
      <div className="container work-container">
        <div className="work-diagram">
          <div className="top-work-diagram">
          Integrate Real Opinion
          </div>
          <div className="middle-work-diagram">
          Users Engage & Earn
          </div>
          <div className="middle-work-diagram-2">
          Users Withdraw Rewards
          </div>
          <div className="bottom-work-diagram">
          You Earn Revenue
          </div>
          <img src="images/work.png" alt="" />
        </div>
        <div className="work-content">
          <p className="work-title">How It Works</p>
          <h2 className="work-heading">
            A Simple, Transparent Monetization Flow
          </h2>
          <div className="work-info-div">
            <div className="work-line-div"></div>
            <p className="work-para">A Simple, Transparent Monetization Flow</p>
            <br />
            <div className="work-info-container">
            {data.map((item, index) => (
              <div className="work-info">
                <h3 className="work-info-title">
                  {`${index + 1}. ` + item.title}
                </h3>
                <p className="work-info-para">{item.content}</p>
              </div>
              
            ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container work-bottom">
        <h2 className="work-heading">Brands Growing with Real Opinion</h2>
        <p>
        At Real Opinion, we don’t just offer a monetization tool — we build lasting partnerships. Our platform is trusted by a growing network of innovative apps, publishers, and digital brands who are focused on scaling revenue through smarter engagement.
        </p>
      </div>
    </section>
  );
};

export default Works;
